import {
  Checkbox,
  Box,
  Flex,
  Heading,
  Image,
  Accordion,
  Progress,
  Center,
  Text,
  Button,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react'
import React, { useContext, useEffect, useState } from 'react'
import { updateUserChecklistStatus } from '../../Api/user'

import { GetStartedContext } from '../../Context/GetStartedContext'
import { Platform } from '../../Context/PlatformContext'
import AuthenticatedRoutes from '../../Utils/AuthenticatedRoutes'
import { getStartedChecklistData } from '../../Utils/data'
import AccordionCheckList from './AccordianChecklist'

const GetStarted = ({openAskArrowhead}) => {
  const { steps, currentStep, moveToNextStep, setGetStarted, setCurrentStep } =
    useContext(GetStartedContext)
  const [currentIndex, setCurrentIndex] = useState(currentStep)

  useEffect(() => {
    setCurrentIndex(currentStep)
  }, [currentStep])
  let length = steps.length
  
  const handleCloseChecklist = () => {
    setGetStarted(false)
    updateUserChecklistStatus(-1)
  }
  return (
    <>
      <AuthenticatedRoutes login={true} />
      {currentIndex < length ? (
        <Box boxShadow='dark-lg' rounded='xl' w='290px'>
          <Accordion allowToggle w='100%' defaultIndex={[0]}>
            <AccordionItem>
              <Flex direction='column'>
                <AccordionButton
                  bgColor='black'
                  borderTopRadius='xl'
                  _hover={{ background: 'black' }}
                >
                  <Box w='100%'>
                    <Box display='flex' justifyContent='space-between'>
                      <Heading size='sm' mb='3' mt='4'>
                        Get started checklist
                      </Heading>
                      <AccordionIcon alignSelf='center' />
                    </Box>
                    <Box display='flex' my='2'>
                      {steps.map((prog) => {
                        return (
                          <Progress
                            key={prog.id}
                            size='xs'
                            flex='.5'
                            value={prog.status === 'COMPLETE' ? '100' : 0}
                            colorScheme='pink'
                            bgColor='#3c3c3c'
                            mr='2'
                          />
                        )
                      })}
                    </Box>
                  </Box>
                </AccordionButton>
                <AccordionPanel bgColor='white' borderBottomRadius='xl'>
                  <Box color='black' px='1' py='2' bgColor='white'>
                    <Accordion index={[Math.floor(currentIndex)]} allowToggle>
                      <AccordionCheckList
                        steps={steps}
                        moveToNextStep={moveToNextStep}
                        setCurrentStep={setCurrentStep}
                        openAskArrowhead={openAskArrowhead}
                      />
                    </Accordion>
                  </Box>
                </AccordionPanel>
              </Flex>
            </AccordionItem>
          </Accordion>
        </Box>
      ) : (
        <Box boxShadow='dark-lg' rounded='xl' w='300px' zIndex='1000'>
          <Flex direction='column'>
            <Box bgColor='black' px='4' py='2' borderTopRadius='xl'>
              <Heading size='sm' mb='3' mt='4'>
                Get started checklist
              </Heading>
              <Box display='flex' my='2'>
                {steps.map((prog) => {
                  return (
                    <Progress
                      key={prog.id}
                      size='xs'
                      flex='.5'
                      value={prog.status === 'COMPLETE' ? '100' : 0}
                      colorScheme='pink'
                      bgColor='#3c3c3c'
                      mr='2'
                    />
                  )
                })}
              </Box>
            </Box>
            <Center
              color='black'
              px='4'
              py='4'
              bgColor='white'
              borderBottomRadius='xl'
            >
              <Box display='flex' flexDirection='column'>
                <Image
                  src='/assets/icons/finishChecklist.svg'
                  alignSelf='center'
                  my='3rem'
                />
                <Box>
                  <Text
                    textAlign='center'
                    fontSize='1rem'
                    fontWeight='700'
                    color='black'
                  >
                    Ready for prime time!
                  </Text>
                  <Text
                    textAlign='center'
                    fontSize='14px'
                    fontWeight='500'
                    color='#222'
                    px='5'
                    mt='1'
                    mb='2.5rem'
                    lineHeight='1.5'
                  >
                    There’s a lot more to discover, but we’ll leave that to you.
                  </Text>
                </Box>
                <Box px='5' mb='5.75rem' alignSelf='center'>
                  <Button
                    color='black'
                    bgColor='white'
                    border='1px solid'
                    borderColor='#EAEAEA'
                    borderRadius='3xl'
                    onClick={handleCloseChecklist}
                  >
                    Dismiss Checklist
                  </Button>
                </Box>
              </Box>
            </Center>
          </Flex>
        </Box>
      )}
    </>
  )
}

export default GetStarted
